import React from 'react'

import { ReportTable } from './components/ReportTable'

export const Report: React.FC = () => {
  return <ReportTable />
}
